define('drops/carouselPanel/carouselPanel',[
    'jquery',
    'underscore',
    'lq/drop'
], function ($, _, Drop) {
    'use strict';

    var defaults = {
        data: {
            color: 'rgba(255, 255, 255, 1)'
        }
    };

    var overrides = {
        data: {
            positioning: 'relative', // the carousel library requires it (and sets it) but applyposition messes it up if this is not set
            position: { x: 0, y: 0 } // position has to be zero to avoid position issues in bxslider
        }
    };

    function CarouselPanel(options) {
        $.extend(true, options, overrides);
        Drop.call(this, $('<li/>'), defaults, options);
        var self = this;

        self.$element
            .addClass('boxToBorderSize')
            .css({
                overflow: 'hidden'
            });

        self.applyColor();
    }

    Drop.extend(CarouselPanel);

    CarouselPanel.typeName = 'CarouselPanel';

    CarouselPanel.prototype.preRender = function () {
        this.data.size = this.parent.data.size;
        this.applyPosition();
    };

    CarouselPanel.prototype.postRender = function () {
        this.$element.height('100%');
    };

    CarouselPanel.prototype.applyColor = function () {
        this.$element
            .css('backgroundColor', this.data.color);
    };

    CarouselPanel.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    return CarouselPanel;
});
